<template>
  <vs-col class="reset-alert-height">
    <vs-alert title="RESUMO FINANCEIRO" color="dark">
      <p v-if="!reEnrollment">
        <strong>Taxa de Matrícula:</strong> {{ taxDueDate }} - R$
        {{ taxValue }}
        <span v-if="!edit"> ({{ taxPayment.DESCRICAO }}) </span>
      </p>
      <p>
        <strong>Forma de Pagamento das Parcelas: </strong>
        <span v-if="!edit">{{ payment.DESCRICAO }},</span> com desconto
        adimplência de: {{ discountPaymentType }}%
      </p>
      <p>
        <strong>Número de Parcelas:</strong> {{ numberOfInstallments }}x com
        primeira parcela para {{ dueDate }}
      </p>
      <div v-if="scholarship || scholarshipExternal || scholarshipCritical">
        <p>
          <strong>Bolsas Adicionadas</strong>
        </p>
        <div style="padding: 10px">
          <li v-if="scholarship">
            {{ scholarship.DESCRICAO }}, {{ scholarship.scholarshipPercent }}% da
            parcela
            {{ scholarship.PARCELAINI }}
            a
            {{ scholarship.PARCELAFIM }}
          </li>
          <li v-if="scholarshipExternal">
            {{ scholarshipExternal.DESCRICAO }},
            {{ scholarshipExternal.scholarshipPercentExternal }}% da
            parcela
            {{ scholarshipExternal.PARCELAINI }}
            a
            {{ scholarshipExternal.PARCELAFIM }}
          </li>
          <li v-if="scholarshipCritical">
            BOLSA TURMA CRÍTICA,
            {{ scholarshipCritical.scholarshipPercentCritical }}% da
            parcela
            {{ scholarshipCritical.PARCELAINI }}
            a
            {{ scholarshipCritical.PARCELAFIM }}
          </li>
        </div>
      </div>

      <p v-if="scholarshipException">
        <strong>Bolsas de Exceção Adicionadas: </strong>
        {{ scholarshipException.DESCRICAO }},
        {{ scholarshipException.scholarshipPercent }}% da parcela
        {{ scholarshipException.PARCELAINI }} a
        {{ scholarshipException.PARCELAFIM }}
      </p>
      <p v-if="scholarshipByAttendance">
        <strong>Benefício adicional pelo tipo de atendimento:</strong><br />
        Desconto de {{ scholarshipByAttendance.PERCENTUAL }}% na parcela
        {{ scholarshipByAttendance.PARCELAINI }} a
        {{ scholarshipByAttendance.PARCELAFIM }}
      </p>

      <div class="center">
        <vs-table
          class="pd-table"
          striped
          :data="installments"
          v-if="installments"
        >
          <vs-tr>
            <th class="center">Parcela</th>
            <th class="center">Valor Bruto</th>
            <th class="center">Bolsa</th>
            <th class="center">Valor Líquido com Bolsa</th>
            <th class="center">Desconto Adimplência</th>
            <th class="center">Valor Líquido</th>
          </vs-tr>
          <vs-tr v-for="(item, i) in installments" :key="i">
            <vs-td>{{ i + 1 }}</vs-td>
            <vs-td>R$ {{ item.valorBrutoParcela.toFixed(2) }}</vs-td>
            <vs-td>{{ item.bolsa }}%</vs-td>
            <vs-td>R$ {{ item.valorComBolsa.toFixed(2) }} </vs-td>
            <vs-td>{{ Number(discountPaymentType) }}% </vs-td>
            <vs-td>R$ {{ item.valorComAdimplencia.toFixed(2) }}</vs-td>
          </vs-tr>
        </vs-table>
      </div>
    </vs-alert>
  </vs-col>
</template>

<script>
import {
  getStepsInformation,
  updateStepsInformation,
} from "../helpers/storage";
import { formatDateToLocale } from "../helpers";

export default {
  name: "SelectedFinancialBox",
  data: () => ({
    tax: null,
    payment: null,
    installment: null,
    scholarship: null,
    scholarshipExternal: null,
    scholarshipException: null,
    scholarshipByAttendance: null,
    numberOfInstallments: null,
    taxPayment: null,
    installments: [],
    discountPaymentType: null,
    edit: false,
    taxDueDate: null,
    dueDate: null,
    taxValue: null,
    reEnrollment: false,
  }),
  created() {
    const stepsData = getStepsInformation();
    if (stepsData.payment) this.payment = stepsData.payment;
    if (stepsData.installment) this.installment = stepsData.installment;
    if (stepsData.tax) this.tax = stepsData.tax;
    if (stepsData.taxPayment) this.taxPayment = stepsData.taxPayment;
    if (stepsData.scholarship) this.scholarship = stepsData.scholarship;
    if (stepsData.scholarshipExternal) this.scholarshipExternal = stepsData.scholarshipExternal;
    if (stepsData.scholarshipCritical)
      this.scholarshipCritical = stepsData.scholarshipCritical;
    if (stepsData.scholarshipException)
      this.scholarshipException = stepsData.scholarshipException;
    if (stepsData.scholarshipByAttendance)
      this.scholarshipByAttendance = stepsData.scholarshipByAttendance;
    if (stepsData.edit) this.edit = stepsData.edit;
    if (stepsData.reEnrollment) this.reEnrollment = stepsData.reEnrollment;

    let valorBrutoParcela = 0;

    if (this.tax) {
      this.taxDueDate = stepsData.tax.dueDate;
      this.taxValue = stepsData.tax.VALORTAXA;
    } else if (this.edit) {
      this.taxDueDate = formatDateToLocale(
        stepsData.preRegistration.DTVENCIMENTOTAXA
      );
      this.taxValue = (
        (Number(stepsData.preRegistration.VALORTAXA) *
          (100 - Number(stepsData.preRegistration.DESCONTOTAXA))) /
        100
      ).toFixed(2);
    }

    if (this.edit && this.installment) {
      valorBrutoParcela =
        (Number(stepsData.preRegistration.VALORPARCELA) *
          Number(stepsData.preRegistration.NUMPARCELA)) /
        this.installment.numberOfInstallments;
    } else if (this.edit && !this.installment) {
      valorBrutoParcela = Number(stepsData.preRegistration.VALORPARCELA);
    } else if (this.reEnrollment) {
      valorBrutoParcela =
        Number(stepsData.offer.VALOR) / this.installment.numberOfInstallments;
    } else {
      valorBrutoParcela =
        Number(stepsData.course.VALOR) / this.installment.numberOfInstallments;
    }

    if (this.installment) {
      this.numberOfInstallments = this.installment.numberOfInstallments;
      this.dueDate = stepsData.installment.dueDate;
    } else {
      this.numberOfInstallments = Number(stepsData.preRegistration.NUMPARCELA);
      this.dueDate = formatDateToLocale(
        stepsData.preRegistration.DTVENCIMENTOPARC
      );
    }

    if (this.payment) this.discountPaymentType = stepsData.payment.PERCDESC;
    else this.discountPaymentType = stepsData.preRegistration.DESCADIM;

    for (let index = 1; index < this.numberOfInstallments + 1; index++) {
      let percentualBolsa = 0;
      if (this.scholarship)
        if (
          index >= parseInt(this.scholarship.PARCELAINI) &&
          index <= parseInt(this.scholarship.PARCELAFIM)
        )
          percentualBolsa = parseFloat(this.scholarship.scholarshipPercent);

      let percentualExterno = 0;
      if (this.scholarshipExternal)
        if (
          index >= parseInt(this.scholarshipExternal.PARCELAINI) &&
          index <= parseInt(this.scholarshipExternal.PARCELAFIM)
        )
          percentualExterno = parseFloat(
            this.scholarshipExternal.scholarshipPercentExternal
          );

      let percentualTurmaCritica = 0;
      if (this.scholarshipCritical)
        if (
          index >= parseInt(this.scholarshipCritical.PARCELAINI) &&
          index <= parseInt(this.scholarshipCritical.PARCELAFIM)
        )
          percentualTurmaCritica = parseFloat(
            this.scholarshipCritical.scholarshipPercentCritical
          );

      let percentualBolsaExcecao = 0;
      if (this.scholarshipException)
        if (
          index >= parseInt(this.scholarshipException.PARCELAINI) &&
          index <= parseInt(this.scholarshipException.PARCELAFIM)
        )
          percentualBolsaExcecao = parseFloat(
            this.scholarshipException.scholarshipPercent
          );

      let percententualDesAdicional = 0;
      if (this.scholarshipByAttendance)
        if (
          index >= parseInt(this.scholarshipByAttendance.PARCELAINI) &&
          index <= parseInt(this.scholarshipByAttendance.PARCELAFIM)
        )
          percententualDesAdicional = parseFloat(
            this.scholarshipByAttendance.PERCENTUAL
          );

      let bolsa =
        percentualBolsa +
        percentualExterno +
        percentualTurmaCritica +
        percentualBolsaExcecao +
        percententualDesAdicional;

      let valorComBolsa = valorBrutoParcela - (valorBrutoParcela * bolsa) / 100;
      let valorComAdimplencia =
        bolsa == 100
          ? valorComBolsa
          : valorComBolsa - (valorComBolsa * this.discountPaymentType) / 100;

      let obj = {
        valorBrutoParcela: valorBrutoParcela,
        bolsa: bolsa,
        valorComBolsa: valorComBolsa,
        valorComAdimplencia: valorComAdimplencia,
      };

      this.installments.push(obj);
    }

    if (this.installments.length > 1) {
      const primeiraParcela = this.installments[0].valorComAdimplencia.toFixed(2);
      const ultimaParcela = this.installments[this.installments.length - 1].valorComAdimplencia.toFixed(2);

      if (primeiraParcela !== ultimaParcela) {
        this.$vs.notify({
          title: 'Erro no cálculo',
          text: 'Os valores líquidos das parcelas estão divergentes. Por favor, verifique as bolsas aplicadas.',
          color: 'danger',
          time: 5000
        });
        this.$router.push('/tax')
      }
    }

    updateStepsInformation({
      scholarshipByAttendance: this.scholarshipByAttendance,
    });
  },
};
</script>


<style>
.reset-alert-height > div {
  height: initial !important;
}
.center {
  text-align: center;
  margin-top: 1%;
}
</style>
